module.exports = __webpack_public_path__ + "static/img/employee-02.935ca0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/community/employee-02.png
// module id = 5aHQ
// module chunks = 2